import React from "react";
import SEO from "../components/SEO";
import { BRAND } from "../lib/brand";

const LEGAL = {
  privacy: {
    title: "Privacy Policy — ProForm Paint & Body",
    heading: "Privacy Policy",
    body: [
      "This site collects only the information you provide directly (name, contact details, vehicle information, uploaded photos, and any messages) for the purpose of responding to your inquiry.",
      "We do not sell your personal information. We use privacy-conscious analytics to understand aggregate site performance — no individual identifiers.",
      "Newsletter subscriptions are opt-in only and never pre-checked. You can request removal at any time by emailing " + BRAND.email + ".",
      "Uploaded photos and inquiry data are stored securely and used only for repair planning and communication with you.",
    ],
  },
  terms: {
    title: "Terms of Use — ProForm Paint & Body",
    heading: "Terms of Use",
    body: [
      "Content on this site is provided for informational purposes only. No estimate, timeline, or repair outcome is guaranteed until an in-person inspection is completed and a written estimate is issued.",
      "Photos and imagery on the site prior to the launch of the archive are atmospheric or licensed placeholders and do not represent completed ProForm work unless clearly identified.",
      "Third-party partner names are used descriptively and do not imply sponsorship or exclusive endorsement.",
      "By submitting an inquiry, you consent to being contacted about your project via your preferred contact method.",
    ],
  },
  accessibility: {
    title: "Accessibility Statement — ProForm Paint & Body",
    heading: "Accessibility",
    body: [
      "ProForm is committed to an accessible web experience. This site targets WCAG 2.2 AA and honors the prefers-reduced-motion media query for motion-sensitive visitors.",
      "If you have trouble using any part of this site, please contact " + BRAND.email + " and we will do our best to help — including providing information in a different format.",
      "Keyboard navigation is supported throughout; visible focus states are provided on interactive elements.",
    ],
  },
};

export default function Legal({ kind = "privacy" }) {
  const d = LEGAL[kind];
  return (
    <>
      <SEO title={d.title} description={d.body[0].slice(0, 160)} canonical={`https://${BRAND.domain}/${kind}`} />
      <section className="pt-32 md:pt-40 pb-24">
        <div className="wrap max-w-3xl">
          <div className="label mb-3">— Legal</div>
          <h1 className="font-display uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight">{d.heading}</h1>
          <div className="mt-10 space-y-6 text-chrome-100 leading-relaxed">
            {d.body.map((p, i) => <p key={i}>{p}</p>)}
          </div>
          <div className="mt-10 label">Last updated: {new Date().toLocaleDateString()}</div>
        </div>
      </section>
    </>
  );
}
